import * as React from 'react'

import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import Btn from './Btn'

interface IProps extends WithI18n {
  loading: boolean;
  cancelLabel: string;
  confirmLabel: string;
  disableNext?: boolean;
  disablePrev?: boolean;
  cancelHandler: () => void;
  confirmHandler: () => void;
}

class BtnActions extends React.Component<IProps, any> {
    render() {
        const {
            cancelHandler, cancelLabel, confirmLabel, confirmHandler, loading, disableNext, disablePrev, t
        } = this.props;
        return(
            <>
                <Btn
                    color="primary"
                    onClick={cancelHandler}
                    disabled={disablePrev || loading}
                >
                    {cancelLabel ? cancelLabel : t.cancel}
                </Btn>
                <Btn
                    loading={loading}
                    onClick={confirmHandler}
                    color="primary"
                    variant="raised"
                    disabled={disableNext || false}
                >
                    {confirmLabel ? confirmLabel : t.confirm}
                </Btn>
            </>
        )
    }
}

export default withI18n(BtnActions)



// WEBPACK FOOTER //
// ./src/shared/Btn/BtnActions.tsx